/**
 * temporal testimonial template
 * @returns {JSX.element} Blog Post react component template
 */
export default function Testimonials() {
  return <section>Testimonials Template</section>;
}
